import { getCalcInputState } from '../../../../../utils/selectors'

export const getSettingsState = (state) => getCalcInputState(state).settings
